import { render, staticRenderFns } from "./CallbackManagement.vue?vue&type=template&id=ec268ac8&scoped=true"
import script from "./CallbackManagement.vue?vue&type=script&lang=js"
export * from "./CallbackManagement.vue?vue&type=script&lang=js"
import style0 from "./CallbackManagement.vue?vue&type=style&index=0&id=ec268ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec268ac8",
  null
  
)

export default component.exports